module.exports = __webpack_public_path__ + "img/day2.fb5b24e2.svg";